var _rect, _g, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 119,
    rx: 59.5,
    fill: "#F9FCEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5055_21601)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M56.6667 53.3333C60.3486 53.3333 63.3333 50.3486 63.3333 46.6667C63.3333 42.9848 60.3486 40 56.6667 40C52.9848 40 50 42.9848 50 46.6667C50 50.3486 52.9848 53.3333 56.6667 53.3333Z",
    fill: "#F9FCEE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M36.667 80.0001H53.3003L50.0003 76.6668L53.1003 73.5334C45.167 74.4334 37.3337 77.9001 36.667 80.0001Z",
    fill: "#F9FCEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6667 59.9999C64.0333 59.9999 70 54.0333 70 46.6666C70 39.2999 64.0333 33.3333 56.6667 33.3333C49.3 33.3333 43.3333 39.2999 43.3333 46.6666C43.3333 54.0333 49.3 59.9999 56.6667 59.9999ZM56.6667 39.9999C60.3333 39.9999 63.3333 42.9999 63.3333 46.6666C63.3333 50.3333 60.3333 53.3333 56.6667 53.3333C53 53.3333 50 50.3333 50 46.6666C50 42.9999 53 39.9999 56.6667 39.9999ZM53.3333 79.9999H36.6667C37.3333 77.8999 45.1667 74.4332 53.1 73.5332H53.2L54.7333 72.0332L60 66.8666C58.7 66.7333 57.7333 66.6666 56.6667 66.6666C47.7667 66.6666 30 71.1333 30 79.9999V86.6666H60L53.3333 79.9999Z",
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6667 63.3333L71.5667 80.5666L64.6667 73.6333L60 78.3333L71.5667 89.9999L93.3333 68.0333L88.6667 63.3333Z",
    fill: "#A9CF3D"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 119,
    rx: 59.5,
    stroke: "#A9CF3D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5055_21601"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupIcon);
export default __webpack_public_path__ + "static/media/signup-icon.07115c21a3d654a562370c230302e7e3.svg";
export { ForwardRef as ReactComponent };